import { render, staticRenderFns } from "./ExaminResultDetail.vue?vue&type=template&id=6f4dd170&scoped=true"
import script from "./ExaminResultDetail.vue?vue&type=script&lang=js"
export * from "./ExaminResultDetail.vue?vue&type=script&lang=js"
import style0 from "./ExaminResultDetail.vue?vue&type=style&index=0&id=6f4dd170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4dd170",
  null
  
)

export default component.exports